// src/env/schema.ts
import { z } from "zod";
var sharedEnvSchema = z.object({
  VITE_API_BASE_URL: z.string().url().optional(),
  VITE_SESSION_INACTIVITY_TIMEOUT: z.coerce.number().positive().optional(),
  VITE_SESSION_WARNING_TIME: z.coerce.number().positive().optional(),
  VITE_SESSION_PRESET: z.enum(["standard", "testing", "development", "extended", "strict"]).optional(),
  VITE_GA_MEASUREMENT_ID: z.string().optional(),
  VITE_I18N_COOKIE_DOMAIN: z.string().optional()
});
var portalEnvSchema = sharedEnvSchema.extend({
  VITE_ONBOARDING_APP_BASE_URL: z.string().url().optional()
});
var onboardingEnvSchema = sharedEnvSchema.extend({
  VITE_PORTAL_APP_BASE_URL: z.string().url().optional()
});

// src/constants/routes.ts
var PORTAL_ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/login/forgot-password",
  ACCOUNT: "/account",
  ACCOUNT_ACTIVATE: "/account/activate",
  ACCOUNT_REQUEST_REACTIVATION: "/account/request-reactivation",
  ACCOUNT_RESET_PASSWORD: "/account/reset-password",
  ACCOUNT_REQUEST_RESET_PASSWORD: "/account/request-reset-password",
  MY_ACCOUNT: "/my-account",
  COMPANY_EDIT: "/my-account/company-details/edit",
  NOTIFICATIONS: "/notifications",
  MY_TASKS: "/my-tasks",
  SUPPORT_TICKETS: "/support-tickets",
  SERVICE_CATALOGUE: "/service-catalogue",
  DASHBOARDS: "/dashboards",
  SERVICES: "/services",
  SOW: "/sow",
  BUNDLE_SOW: "/bundle-sow",
  ACTIVITY_REQUEST: "/activity-request",
  NDA: "/nda",
  KYB: "/kyb",
  MSA: "/msa",
  MSA_INITIATE: "/msa/initiate",
  MSA_REVIEW: "/msa/review",
  PROOF_OF_PAYMENT: "/proof-of-payment",
  APP_INFO: "/app-info",
  // TDF-1389: Super Admin chooses which client to act for. Sits between login
  // and the portal; nothing else is reachable until a company is chosen.
  SELECT_COMPANY: "/select-company",
  // TDF-1461: TASAMA back-office, only reachable by a Super Admin.
  SUPER_ADMIN_CATALOG_SYNC: "/super-admin/catalog-sync",
  TASAMA_WEBSITE: "https://tasama.com.sa/"
};
var ONBOARDING_ROUTES = {
  ROOT: "/onboarding",
  APP_INFO: "/app-info"
};
var EXTERNAL_ROUTES = {
  TASAMA_WEBSITE: "https://tasama.com.sa/",
  CONTACT_ME: "https://tasama.com.sa/en/contact.html#contact"
};

// src/constants/api.ts
var API_PATHS = {
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    ME: "/auth/me"
  },
  USERS: {
    ROOT: "/users",
    BY_ID: (id) => `/users/${id}`
  }
};
var API_VERSION = "v1";

// src/feature-flags/flags.ts
var FeatureFlags = {
  LANGUAGE_SWITCHER: "LANGUAGE_SWITCHER"
};
var FEATURE_FLAGS = {
  /** Enable the service catalogue L2 detail page */
  SERVICE_CATALOGUE_L2: true,
  /** Enable the notifications centre */
  NOTIFICATIONS: true,
  /** Enable the support ticketing module */
  SUPPORT_TICKETS: true,
  /** Enable the language switcher UI — hidden until localisation is ready for release */
  LANGUAGE_SWITCHER: true
};
var isEnabled = (flag) => FEATURE_FLAGS[flag];
export {
  API_PATHS,
  API_VERSION,
  EXTERNAL_ROUTES,
  FEATURE_FLAGS,
  FeatureFlags,
  ONBOARDING_ROUTES,
  PORTAL_ROUTES,
  isEnabled,
  onboardingEnvSchema,
  portalEnvSchema,
  sharedEnvSchema
};
//# sourceMappingURL=index.js.map